var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.00011V13.0001C16 13.7958 16.3161 14.5588 16.8787 15.1214C17.4413 15.684 18.2044 16.0001 19 16.0001C19.7957 16.0001 20.5587 15.684 21.1213 15.1214C21.6839 14.5588 22 13.7958 22 13.0001V12.0001C21.9999 9.74314 21.2362 7.55259 19.8333 5.78464C18.4303 4.0167 16.4706 2.77534 14.2726 2.26241C12.0747 1.74948 9.76794 1.99515 7.72736 2.95948C5.68677 3.9238 4.03241 5.55007 3.03327 7.57383C2.03413 9.5976 1.74898 11.8998 2.22418 14.1062C2.69938 16.3126 3.90699 18.2933 5.65064 19.7264C7.39429 21.1594 9.57144 21.9605 11.8281 21.9993C14.0847 22.0381 16.2881 21.3124 18.08 19.9401M16 12.0001C16 14.2093 14.2092 16.0001 12 16.0001C9.79087 16.0001 8.00001 14.2093 8.00001 12.0001C8.00001 9.79097 9.79087 8.00011 12 8.00011C14.2092 8.00011 16 9.79097 16 12.0001Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtSign);
export default __webpack_public_path__ + "static/media/at-sign.03dc6e3d594cc134a9ac909f6d003ddb.svg";
export { ForwardRef as ReactComponent };